/**
 * rewardDataGap — bekannte, kontounabhängige Reward-Datenlücke.
 *
 * Für den Zeitraum Februar 2025 bis Juni 2026 (inklusive) existieren im
 * Backend für KEIN Konto Reward-Datensätze — die historischen Daten sind
 * noch nicht nachbefüllt (Backfill folgt nach dem Livegang). Das Backend
 * unterscheidet nicht zwischen "Periode hat keine Daten" und "Periode hat
 * legitim 0 Rewards" (siehe monthly_report_calculator.rb) — eine Anfrage
 * liefert in beiden Fällen schlicht 0 zurück. Diese Konstante ist daher
 * bewusst hart codiert (kein Rateversuch anhand der Response) und sicher,
 * WEIL das Fenster ein deklarierter, vollständiger, kontounabhängiger
 * Ausfall ist — keine Interpretation mehrdeutiger Nullen.
 */

/** Erster Monat der Lücke (inklusive), "YYYY-MM". */
export const REWARD_DATA_GAP_START = '2025-02'
/** Letzter Monat der Lücke (inklusive), "YYYY-MM". */
export const REWARD_DATA_GAP_END = '2026-06'

/** True, wenn `period` ("YYYY-MM") innerhalb der bekannten Datenlücke liegt. */
export function isPeriodInRewardDataGap(period: string): boolean {
  return period >= REWARD_DATA_GAP_START && period <= REWARD_DATA_GAP_END
}

function toPeriod(date: Date | string): string | undefined {
  const d = typeof date === 'string' ? new Date(date) : date
  if (Number.isNaN(d.getTime())) return undefined
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

/** True, wenn das Datum (Kalendermonat) innerhalb der bekannten Datenlücke liegt. */
export function isDateInRewardDataGap(date: Date | string): boolean {
  const period = toPeriod(date)
  if (!period) return false
  return isPeriodInRewardDataGap(period)
}

/** True, wenn irgendein Monat von `year` innerhalb der bekannten Datenlücke liegt. */
export function isYearInRewardDataGap(year: number): boolean {
  const yearStart = `${year}-01`
  const yearEnd = `${year}-12`
  return yearStart <= REWARD_DATA_GAP_END && yearEnd >= REWARD_DATA_GAP_START
}
